const SWATCHES: { name: string; var: string }[] = [
  { name: "canvas", var: "--mii-canvas" },
  { name: "surface-1", var: "--mii-surface-1" },
  { name: "surface-2", var: "--mii-surface-2" },
  { name: "surface-3", var: "--mii-surface-3" },
  { name: "surface-4", var: "--mii-surface-4" },
  { name: "accent", var: "--mii-accent" },
];

export function TokenSwatchGrid() {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {SWATCHES.map(s => (
        <div
          key={s.var}
          className="overflow-hidden rounded-lg border border-border"
        >
          <div
            className="h-24 w-full"
            style={{ backgroundColor: `var(${s.var})` }}
          />
          <div className="border-t border-border bg-surface-1/80 p-3">
            <p className="font-mono text-[0.65rem] uppercase tracking-widest text-ink-tertiary">
              {s.name}
            </p>
            <p className="mt-1 font-mono text-xs text-ink-secondary">{s.var}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
